import React from "react";
import styled from "styled-components";
import PositionContainer from "../shared/container";
import Title from "../shared/titles";
import Paragraph from "../shared/paragraphs";
import { useIntl } from "gatsby-plugin-react-intl";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 317px;
  background: #fbfbfb;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;

  @media (max-width: 960px) {
    height: max-content;
    padding: 40px 0px;
  }
`;

const ContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const TitleHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    width: 324px;
  }

  @media (max-width: 350px) {
    width: 100%;
  }
`;

const TextBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 792px;

  @media (max-width: 960px) {
    width: 100%;
  }
`;

function Where() {
  const intl = useIntl();

  return (
    <Container>
      <PositionContainer>
        <ContentHolder>
          <TitleHolder>
            <Title margin="0px 0px 29px 0px">
              {intl.formatMessage({
                id: "InstructionWhereTitle",
              })}
            </Title>
          </TitleHolder>
          <TextBox>
            <Paragraph type="center">
              {intl.formatMessage({
                id: "InstructionWhereParagraph",
              })}
            </Paragraph>
          </TextBox>
        </ContentHolder>
      </PositionContainer>
    </Container>
  );
}

export default Where;
